import * as React from 'react'

const SvgWarningAltFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.675 17.2L10.55 1.575a.625.625 0 00-1.1 0L1.325 17.2a.625.625 0 000 .625.625.625 0 00.55.3h16.25a.625.625 0 00.55-.925zM9.3 6.25h1.406v6.25H9.3V6.25zm.7 10a.937.937 0 110-1.875.937.937 0 010 1.875z"
      fill="#163250"
    />
  </svg>
)

export default SvgWarningAltFilledIcon
